import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-model/brand-kit";
import * as classNames from "classnames";
import {
  RedoPhoneNumberInput,
  RedoPhoneNumberInputProps,
} from "./arbiter-components/input/redo-phone-number-input";
import {
  RedoTextInput,
  RedoTextInputProps,
} from "./arbiter-components/input/redo-text-input";
import * as css from "./brand-kit-text-input.module.css";
import { getInputStyles } from "./brand-kit-utils";

/* Memoizing this causes the signup form builder to not update the override styles */
export const BrandKitTextInput = function BrandKitTextInput({
  brandKit,
  override,
  ...props
}: Omit<RedoTextInputProps, "style"> & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
}) {
  const style = getInputStyles(brandKit, override);
  return (
    <RedoTextInput
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};

export const BrandKitPhoneNumberInput = function BrandKitPhoneNumberInput({
  brandKit,
  override,
  ...props
}: RedoPhoneNumberInputProps & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
}) {
  const style = getInputStyles(brandKit, override);

  return (
    <RedoPhoneNumberInput
      className={classNames(
        css.brandKitTextInput,
        css.brandKitPhoneNumberInput,
      )}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};
